var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.tooltipClass},[_vm._t("default"),_c('span',{staticClass:"ds-tooltip__content",attrs:{"ds-component":"DsTooltip"}},[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }